import React, { createContext, useContext, useEffect } from "react";
import { ComponentPermission, PermissionContext, PermissionProps } from "../../Model/Permission";
import { getUserCredential } from "../../redux/reducers/LocalUserReducer";
import { useTypedSelector } from "../../redux/reducers/RootReducer";
import UserCredentialUtil from "../../Utility/UserCredentialUtil";
import { isAuthenticationEnable } from "../../redux/reducers/AuthenticationSettingReducer";

type props = {
  children: any;
};

const PermissionCtx = createContext<PermissionContext>({
  permissions: [],
});

export const PermissionProvider = ({ children }: props) => {
  const user = useTypedSelector((state) => getUserCredential(state));
  const isAuthEnable: boolean = useTypedSelector((state) => isAuthenticationEnable(state));
  const pagePermissions = isAuthEnable ? UserCredentialUtil.getUserComponentPermission(user) : UserCredentialUtil.autoLoginPermission();
  const permissionCtx = {
    permissions: pagePermissions,
  };

  return <PermissionCtx.Provider value={permissionCtx}>{children}</PermissionCtx.Provider>;
};

const usePermission = <T extends React.ComponentType<any>>(WrappedComponent: T) => {
  type P = React.ComponentProps<T>;
  type IntrinsicProps = JSX.IntrinsicAttributes & JSX.LibraryManagedAttributes<T, { children?: React.ReactNode }>;
  type WrappedProps = P & IntrinsicProps & {};
  return function WithPermission(props: P & PermissionProps) {
    const permissionCtx = useContext(PermissionCtx);

    return <WrappedComponent {...(props as unknown) as WrappedProps} permissions={permissionCtx.permissions} />;
  };
};

export { usePermission };
